import React from 'react';

const MagnifyingGlass = () => (
  <svg
    className="magnifying-glass"
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.622 10.886c2.654 0 4.805-2.113 4.805-4.72 0-2.606-2.151-4.72-4.805-4.72-2.653 0-4.804 2.114-4.804 4.72 0 2.607 2.15 4.72 4.804 4.72z"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.435 10.28l-4.912 4.825" stroke="#fff" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

export default MagnifyingGlass;
